import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { BLOCKCHAIN_NETWORK_ID } from '~/types'

export const createVerificationMessage = (address: BlockchainAddress, accountId: number) => {
  const blockchainName = address.blockchain.toString().toUpperCase()
  const chainId = BLOCKCHAIN_NETWORK_ID[blockchainName as keyof typeof BLOCKCHAIN_NETWORK_ID]
  const verifyingContractZeroPlaceholder = '0x0000000000000000000000000000000000000000'
  if (!chainId) {
    throw new Error(`Unsupported blockchain: ${address.blockchain}`)
  }

  const message = {
    types: {
      EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'verifyingContract', type: 'address' },
      ],
      VerifyAddress: [
        { name: 'address', type: 'address' },
        { name: 'blockchain', type: 'string' },
        { name: 'accountId', type: 'uint256' },
        { name: 'timestamp', type: 'uint256' },
      ],
    },
    primaryType: 'VerifyAddress',
    domain: {
      name: 'StraitsX Address Verification',
      version: '1',
      chainId: chainId.toString(),
      verifyingContract: verifyingContractZeroPlaceholder,
    },
    message: {
      address: address.address,
      blockchain: address.blockchain,
      accountId: accountId.toString(),
      timestamp: Math.floor(Date.now() / 1000).toString(),
    },
  }

  return message
}
